import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPlusCircle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--plus-circle")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M12,7 C12.5522847,7 13,7.44771525 13,8 L13,8 L13,11 L16,11 C16.5128358,11 16.9355072,11.3860402 16.9932723,11.8833789 L17,12 C17,12.5522847 16.5522847,13 16,13 L16,13 L13,13 L13,16 C13,16.5128358 12.6139598,16.9355072 12.1166211,16.9932723 L12,17 C11.4477153,17 11,16.5522847 11,16 L11,16 L11,13 L8,13 C7.48716416,13 7.06449284,12.6139598 7.00672773,12.1166211 L7,12 C7,11.4477153 7.44771525,11 8,11 L8,11 L11,11 L11,8 C11,7.48716416 11.3860402,7.06449284 11.8833789,7.00672773 Z" id="icon--centivo--plus-circle"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1267.000000, -973.000000)"/>
          <g id="Icon/plus-circle">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--plus-circle"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--plus-circle"/>
          </g>
      </g>
  </IconWrapper>
)
